<template>
  <div class="videoIntercom">
    <el-dialog
      ref="videoIntercomDialog"
      :title="$l(title)"
      :visible.sync="videoIntercomDialog"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      width="768px"
    >
      <div>
        <iframe
          id="intercom"
          :src="src"
          width="100%"
          height="100%"
          title=""
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "videoIntercom",
  props: {},
  data() {
    return {
      title: "对讲",
      videoIntercomDialog: false,
      src: "",
    };
  },
  methods: {
    play(data) {
      this.src = `/edb/html/webmain.html?loginName=${data.loginName}&password=${data.password}&phone=${data.phone}&key=${data.key}&loginType=sip&agentStatus=0`;
      this.videoIntercomDialog = true;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
#intercom {
  border: none;
}
</style>
